import { render, staticRenderFns } from "./FrictionStandardization.vue?vue&type=template&id=28bc090c&"
import script from "./FrictionStandardization.vue?vue&type=script&lang=js&"
export * from "./FrictionStandardization.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports